import { Link } from "react-router-dom";

export default function Logo({ light = false }) {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className="inline-flex items-start select-none"
      aria-label="Vibe home"
    >
      <span
        className={`text-[2.55rem] leading-none font-extrabold lowercase tracking-[-0.045em] ${
          light ? "text-[#E8F3EB]" : "text-[#1B4332]"
        }`}
      >
        vibe
        <span className="text-[0.32em] font-bold align-super ml-[2px]">®</span>
      </span>
    </Link>
  );
}
